(function() {
var FilterBar,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

FilterBar = (function() {
  function FilterBar() {
    this.get_params_from_filters = bind(this.get_params_from_filters, this);
    this.enable_filter_actions = bind(this.enable_filter_actions, this);
    this.disable_filter_actions = bind(this.disable_filter_actions, this);
    this.update_filtered_list = bind(this.update_filtered_list, this);
    this.render_filter_menu_item = bind(this.render_filter_menu_item, this);
    this.render_filter_menu = bind(this.render_filter_menu, this);
    this.close_filters = bind(this.close_filters, this);
    this.clicked_on_a_clear_filters_btn = bind(this.clicked_on_a_clear_filters_btn, this);
    this.clicked_on_filter_item = bind(this.clicked_on_filter_item, this);
    this.clicked_on_filter = bind(this.clicked_on_filter, this);
    this.setup_listeners = bind(this.setup_listeners, this);
    this.get_filter = bind(this.get_filter, this);
    this.clear_state = bind(this.clear_state, this);
    this.print_filter_state = bind(this.print_filter_state, this);
    this.filter_controls_datatable = false;
    this.update_browser_history = false;
    this.filter_url_datatype = "script";
    this.filters = [];
    this.filter_bar_wrapper = $('[data-filter-bar]');
    this.filter_bar_id = this.filter_bar_wrapper.data("filter-bar");
    this.filter_bar_base_url = this.filter_bar_wrapper.data("filter-bar-base-url");
    this.filter_bar_filter_url = this.filter_bar_wrapper.data("filter-bar-filter-url") || this.filter_bar_base_url;
    this.update_browser_history = this.filter_bar_wrapper.data("filter-bar-update-history") === true;
    this.filter_bar_flyout = $(".filter_bar_flyout");
    this.clear_filters_buttons = $(".clear_filters_btn[data-filter-bar-id='" + this.filter_bar_id + "']");
    this.filtered_content_area = $(".filtered_content");
    this.filter_datatable_selector = this.filter_bar_wrapper.data("filter-bar-datatable");
    if (this.filter_datatable_selector) {
      this.filter_controls_datatable = true;
    }
    $(".filter_bar .btn-filter").each((function(_this) {
      return function(index, element) {
        var _elem, _filter_param, _filter_value;
        _elem = $(element);
        _filter_param = _elem.data("filter-param");
        _filter_value = _elem.data("filter-value");
        _filter_value = "" + _filter_value;
        if (_filter_value === "") {
          _filter_value = [];
        } else {
          _filter_value = _filter_value.split(",");
        }
        return _this.filters.push({
          param: _filter_param,
          value: _filter_value,
          state: "closed"
        });
      };
    })(this));
    this.setup_listeners();
  }

  FilterBar.prototype.print_filter_state = function() {
    var filter, i, len, ref, results;
    console.log("print filter state.......");
    ref = this.filters;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      filter = ref[i];
      results.push(console.log(filter));
    }
    return results;
  };

  FilterBar.prototype.clear_state = function() {};

  FilterBar.prototype.get_filter = function(filter_param) {
    var filter, i, len, ref;
    ref = this.filters;
    for (i = 0, len = ref.length; i < len; i++) {
      filter = ref[i];
      if (filter.param === filter_param) {
        return filter;
      }
    }
    return null;
  };

  FilterBar.prototype.setup_listeners = function() {
    $(document).off("click", ".filter_bar .btn-filter");
    $(document).off("click", ".filter_bar_flyout_menu .btn-filter");
    $(document).off("click", ".clear_filters_btn");
    $(document).off("click", ".filter_bar_flyout .show_filtered_data_btn");
    $(document).off("click", "body");
    $(document).on("click", ".filter_bar .btn-filter", (function(_this) {
      return function(event) {
        event.preventDefault();
        return _this.clicked_on_filter(event);
      };
    })(this));
    $(document).on("click", ".filter_bar_flyout_menu .btn-filter", (function(_this) {
      return function(event) {
        event.preventDefault();
        return _this.clicked_on_filter_item(event);
      };
    })(this));
    $(document).on("click", ".clear_filters_btn", (function(_this) {
      return function(event) {
        var $elem, _filter_bar_id;
        $elem = $(event.target);
        _filter_bar_id = $elem.data("filter-bar-id");
        event.preventDefault();
        if (_filter_bar_id === _this.filter_bar_id) {
          console.log("filter bar matches so clearing filter bar");
          return _this.clicked_on_a_clear_filters_btn(event);
        }
      };
    })(this));
    $(document).on("click", ".filter_bar_flyout .show_filtered_data_btn", (function(_this) {
      return function(event) {
        event.preventDefault();
        return _this.close_filters(event);
      };
    })(this));
    return $(document).on("click", "body", (function(_this) {
      return function(event) {
        var _elem;
        _elem = event.target.closest(".filter_bar_wrapper");
        if (!_elem) {
          return _this.close_filters();
        }
      };
    })(this));
  };

  FilterBar.prototype.clicked_on_filter = function(event) {
    var $elem, _filter, _filter_param, filter, i, len, ref;
    $elem = $(event.target).closest(".btn-filter");
    _filter_param = $elem.data("filter-param");
    _filter = this.get_filter(_filter_param);
    if (_filter.state === "closed") {
      ref = this.filters;
      for (i = 0, len = ref.length; i < len; i++) {
        filter = ref[i];
        filter.state = "closed";
      }
      _filter.state = "open";
    } else {
      _filter.state = "closed";
    }
    return this.render_filter_menu();
  };

  FilterBar.prototype.clicked_on_filter_item = function(event) {
    var $button_elem, $flyout_menu, _current_filter_value, _filter, _filter_param, _item_value;
    $button_elem = $(event.target).closest(".btn-filter");
    $flyout_menu = $button_elem.closest(".filter_bar_flyout_menu");
    _item_value = $button_elem.data("filter-item-value");
    _filter_param = $flyout_menu.data("filter-param");
    _filter = this.get_filter(_filter_param);
    _current_filter_value = _filter.value;
    if (_current_filter_value.indexOf("" + _item_value) !== -1) {
      _filter.value = _filter.value.filter(function(id) {
        return id !== ("" + _item_value);
      });
    } else {
      _filter.value.push("" + _item_value);
    }
    this.render_filter_menu();
    return this.update_filtered_list();
  };

  FilterBar.prototype.clicked_on_a_clear_filters_btn = function(event) {
    var filter, i, len, ref;
    ref = this.filters;
    for (i = 0, len = ref.length; i < len; i++) {
      filter = ref[i];
      filter.value = [];
    }
    this.render_filter_menu();
    return this.update_filtered_list();
  };

  FilterBar.prototype.close_filters = function() {
    var filter, i, len, ref;
    ref = this.filters;
    for (i = 0, len = ref.length; i < len; i++) {
      filter = ref[i];
      filter.state = "closed";
    }
    return this.render_filter_menu();
  };

  FilterBar.prototype.render_filter_menu = function() {
    var _num_selected_filter_items, filter, i, len, ref;
    this.filter_bar_flyout.hide();
    this.filter_bar_flyout.removeClass("filter_bar_flyout_open");
    this.filtered_content_area.css({
      opacity: 1
    });
    ref = this.filters;
    for (i = 0, len = ref.length; i < len; i++) {
      filter = ref[i];
      this.render_filter_menu_item(filter);
    }
    _num_selected_filter_items = (this.filters.map(function(filter) {
      return filter.value.length;
    })).reduce(function(a, b) {
      return a + b;
    });
    if (_num_selected_filter_items > 0) {
      return this.clear_filters_buttons.fadeIn('fast');
    } else {
      return this.clear_filters_buttons.fadeOut('fast');
    }
  };

  FilterBar.prototype.render_filter_menu_item = function(filter) {
    var $filter_bar_flyout_menu, $filter_bar_menu_item, $filter_num_span, _highlight, _num_selected, _num_selected_text, _open_state, _values, i, len, ref, results, value;
    $filter_bar_menu_item = $(".filter_bar .btn-filter[data-filter-param='" + filter.param + "']");
    $filter_bar_flyout_menu = $(".filter_bar_flyout_menu[data-filter-param='" + filter.param + "']");
    $filter_num_span = $filter_bar_menu_item.find(".filter_num");
    _values = filter.value;
    _num_selected = _values.length;
    _open_state = filter.state === "open";
    _highlight = _open_state || _num_selected > 0;
    if (_highlight) {
      $filter_bar_menu_item.addClass("btn-filter-selected");
    } else {
      $filter_bar_menu_item.removeClass("btn-filter-selected");
    }
    _num_selected_text = _num_selected > 0 ? "(" + _num_selected + ")" : "";
    $filter_num_span.html(_num_selected_text);
    if (_num_selected > 0) {
      $filter_num_span.addClass("filter_num_selected");
    } else {
      $filter_num_span.removeClass("filter_num_selected");
    }
    if (_open_state) {
      $filter_bar_menu_item.find("span.filter_triangle_down").removeClass("filter_triangle_down").addClass("filter_triangle_up");
      this.filter_bar_flyout.show();
      this.filter_bar_flyout.addClass("filter_bar_flyout_open");
      $filter_bar_flyout_menu.show();
      $filter_bar_flyout_menu.find(".btn-filter-selected").removeClass("btn-filter-selected");
      ref = filter.value;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        value = ref[i];
        results.push($filter_bar_flyout_menu.find(".btn-filter[data-filter-item-value='" + value + "']").addClass("btn-filter-selected"));
      }
      return results;
    } else {
      $filter_bar_menu_item.find("span.filter_triangle_up").removeClass("filter_triangle_up").addClass("filter_triangle_down");
      return $filter_bar_flyout_menu.hide();
    }
  };

  FilterBar.prototype.update_filtered_list = function() {
    var _history_full_path, _load_data_path, _params, datatable;
    _params = this.get_params_from_filters();
    _load_data_path = this.filter_bar_filter_url;
    if (this.filter_url_datatype === "json") {
      _load_data_path += ".json";
    }
    _load_data_path = window.alpha_oms_utils.append_params(_load_data_path, _params);
    _history_full_path = window.alpha_oms_utils.append_params(this.filter_bar_base_url, _params);
    if (this.update_browser_history) {
      if (window.history) {
        window.history.replaceState({}, "", _history_full_path);
      }
    }
    if (this.filter_controls_datatable) {
      datatable = $(this.filter_datatable_selector).DataTable({
        retrieve: true
      });
      datatable.ajax.url(_load_data_path);
      return datatable.ajax.reload();
    } else {
      this.disable_filter_actions();
      return $.get(_load_data_path, {
        dataType: "script"
      }).always((function(_this) {
        return function() {
          return _this.enable_filter_actions();
        };
      })(this));
    }
  };

  FilterBar.prototype.disable_filter_actions = function() {
    return this.filtered_content_area.css({
      opacity: 0.3
    });
  };

  FilterBar.prototype.enable_filter_actions = function() {
    return this.filtered_content_area.css({
      opacity: 1
    });
  };

  FilterBar.prototype.get_params_from_filters = function() {
    var _params_string, string_parts;
    _params_string = "";
    string_parts = [];
    $.each(this.filters, function(index, filter) {
      var _values_string;
      if (filter.value.length > 0) {
        _values_string = filter.value.join("%2C");
        return string_parts.push(filter.param + "=" + _values_string);
      }
    });
    return string_parts.join("&");
  };

  return FilterBar;

})();

window.alpha_oms.filter_bar_constructor = FilterBar;

}).call(window);
